
export default {
  name: 'LeftNav',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    revalStatus: {
      type: String,
      default: () => ''
    }
  }
}
